module.exports = __webpack_public_path__ + "img/schedule_edit.f396106a.png";